<div class="bg-white">
  <div class="row">
    <div class="card-header bg-very-light-gray small-12 column">
      <div id="toggle-linear" class="card-title card-padding flex margin-all">
        <h2>{{(isCreation ? 'assistance.add-new-assistance' : 'assistance.edit-assistance') | translate}}</h2>
      </div>
    </div>
    <form [formGroup]="profileForm!" (ngSubmit)="saveEvent()" class="bg-white padding-v margin-t">
      <div class="small-12 columns">
        <label><b>{{'title' | translate}} </b><span class="c-alert">*</span>
          <input formControlName="label" type="text" placeholder="Title">
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.category' | translate}} </b><span class="c-alert">*</span>
          <select name="Catégorie" formControlName="categorySelected">
            <option *ngFor="let category of categories" [value]="category">
              {{ category }}
            </option>
          </select>
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.sub-category' | translate}}  </b>
          <select name="Souscatégorie" formControlName="subCategorySelected">
            <option *ngFor="let subCategory of subCategories" [value]="subCategory">
              {{ subCategory }}
            </option>
          </select>
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.solution' | translate}} </b><span class="c-alert">*</span>
          <select name="Solution" formControlName="solutionSelected">
            <option *ngFor="let solution of solutions" [value]="solution">
              {{ solution | applicationName }}
            </option>
          </select>
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.status' | translate}} </b><span class="c-alert">*</span>
          <select name="Status" formControlName="statusSelected">
            <option *ngFor="let status of statusList" [value]="status">
              {{ status }}
            </option>
          </select>
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.importance' | translate}} </b><span class="c-alert">*</span>
          <select name="Importance" formControlName="importanceSelected">
            <option *ngFor="let importance of importanceList" [value]="importance">
              {{ importance }}
            </option>
          </select>
        </label>
      </div>
      <div class="small-4 columns">
        <label><b>{{'assistance.publication-date' | translate}} </b><span class="c-alert">*</span>
          <mat-form-field>
            <input [matDatepicker]="publicationDatePicker" formControlName="publicationDate" matInput
                   name="publicationDate">
            <mat-datepicker-toggle matSuffix [for]="publicationDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #publicationDatePicker></mat-datepicker>
          </mat-form-field>
        </label>
      </div>
      <div class="small-4 columns text-right margin-t-l margin-b-l">
        <input [disabled]="profileForm?.status === 'INVALID'" type="submit" value="Enregistrer" class="button success margin-r-xs">
      </div>
    </form>
  </div>
</div>
